var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendorName(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.94371 5.36V9.1336C2.94371 10.0555 2.94371 10.5165 3.24849 10.8029C3.55326 11.0893 3.95227 11.0893 4.93332 11.0893H8.2362C9.21724 11.0893 9.61808 11.0893 9.92286 10.8029C10.2276 10.5165 10.2276 10.0555 10.2276 9.1336V5.36M1.5167 4.34556L2.71067 2.32956C2.83165 2.12528 3.05145 2 3.28887 2H10.1872C10.4435 2 10.6774 2.14575 10.7904 2.37578L11.7804 4.39178C11.9997 4.8383 11.6747 5.36 11.1772 5.36H2.0949C1.57427 5.36 1.2514 4.79352 1.5167 4.34556Z",
    stroke: "#111D31",
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorName);
export default __webpack_public_path__ + "static/media/vendorName.21bf45676206a073dd929b6715532c3f.svg";
export { ForwardRef as ReactComponent };